<div style="width:1250px; margin:0 auto; position:relative;font-family:'微軟正黑體',Arial">
  <img *ngIf="((clo024|async)?.count??0)>=1" src="images/IDBG.jpg" style="width:100%; height:auto;">
  <img *ngIf="((clo024|async)?.count??0)==0" src="images/IDBG_e.jpg" style="width:100%; height:auto;">
  <div style="position:absolute; width:620px; top:60px; right:260px; text-align:right;">
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613;">學生</span>
    <span
      style="font-size:36px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.cH_NAME}}</span>
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613; margin-top:0;">在本校修習</span>
    <span style="font-size:32px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_NAME}}
      <span style=" color:#221613;">成績及格</span></span>
    <span style=" display:block; margin-top: 10px; font-size:15px; font-weight:bold; color:#221613; line-height:28px;">
      This certifies that <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.engname}}</span><br>
      has completed the requirements of <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_ENG_NAME}}</span>
    </span>
    <ul style=" margin-top:20px; border-right:#e6c5c1 1px solid;">
      <span
        style=" display:inline-block; padding: 0 10px 5px 0; border-right:#e6c5c1 1px solid; width:495px;"><b>課程名稱</b><br><span
          style="font-size:15px;">Course</span></span><span
        style=" width:60px; display:inline-block; padding: 0 10px 5px 0;"><b>學分數</b><br><span
          style="font-size:15px;">Credits</span></span>
      <li *ngFor="let t of (clo029|async) |  slice:0:9; let i=index" style="list-style:none; font-size:11px;">
        <span style=" display:inline-block; width:495px; padding-right:10px; border-right:#e6c5c1 1px solid;">
          <span
            style="font-size:15px; font-weight:bold; display:block; color:#8b5c2e; padding-top:7px;">{{t.cH_LESSON}}</span>{{t.enG_LESSON}}</span><span
          style=" width:60px; display:inline-block; vertical-align: top; padding-right:10px; font-size:22px; font-weight:bold; color:#8b5c2e;">{{t.crd}}</span>
      </li>
    </ul>
  </div>
  <span
    style=" position:absolute; right:280px; text-align:right; width:710px; display:block; bottom:55px; font-size:13px; color:#333; font-weight:bold;"><img
      src="images/vC.gif" width="120" height="24" align="absmiddle"
      style="display:inline-block; margin-right:20px;"><span
      style="color:#8d2c2d; display:inline-block; margin: 0 5px;">Issued │ </span>
    {{today|date:'MMMM dd yyyy'}}
    <span *ngIf="((clo029|async)?.length??0)>9"
      style="color:#8d2c2d; display:inline-block; margin: 0 5px 0 20px;"> (1/2)
    </span>
  </span>
</div>

<div style="width:1250px; margin:0 auto; position:relative;font-family:'微軟正黑體',Arial" *ngIf="((clo029|async)?.length??0)>9">
  <img *ngIf="((clo024|async)?.count??0)>=1" src="images/IDBG.jpg" style="width:100%; height:auto;">
  <img *ngIf="((clo024|async)?.count??0)==0" src="images/IDBG_e.jpg" style="width:100%; height:auto;">
  <div style="position:absolute; width:620px; top:60px; right:260px; text-align:right;">
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613;">學生</span>
    <span
      style="font-size:36px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.cH_NAME}}</span>
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613; margin-top:0;">在本校修習</span>
    <span style="font-size:32px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_NAME}}
      <span style=" color:#221613;">成績及格</span></span>
    <span style=" display:block; margin-top: 10px; font-size:15px; font-weight:bold; color:#221613; line-height:28px;">
      This certifies that <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.engname}}</span><br>
      has completed the requirements of <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_ENG_NAME}}</span>
    </span>
    <ul style=" margin-top:20px; border-right:#e6c5c1 1px solid;">
      <span
        style=" display:inline-block; padding: 0 10px 5px 0; border-right:#e6c5c1 1px solid; width:495px;"><b>課程名稱</b><br><span
          style="font-size:15px;">Course</span></span><span
        style=" width:60px; display:inline-block; padding: 0 10px 5px 0;"><b>學分數</b><br><span
          style="font-size:15px;">Credits</span></span>
      <li *ngFor="let t of (clo029|async) |  slice:10:18; let i=index" style="list-style:none; font-size:11px;">
        <span style=" display:inline-block; width:495px; padding-right:10px; border-right:#e6c5c1 1px solid;">
          <span
            style="font-size:15px; font-weight:bold; display:block; color:#8b5c2e; padding-top:7px;">{{t.cH_LESSON}}</span>{{t.enG_LESSON}}</span><span
          style=" width:60px; display:inline-block; vertical-align: top; padding-right:10px; font-size:22px; font-weight:bold; color:#8b5c2e;">{{t.crd}}</span>
      </li>
    </ul>
  </div>
  <span
    style=" position:absolute; right:280px; text-align:right; width:710px; display:block; bottom:55px; font-size:13px; color:#333; font-weight:bold;"><img
      src="images/vC.gif" width="120" height="24" align="absmiddle"
      style="display:inline-block; margin-right:20px;"><span
      style="color:#8d2c2d; display:inline-block; margin: 0 5px;">Issued │ </span>
    {{today|date:'MMMM dd yyyy'}}
    <span
      style="color:#8d2c2d; display:inline-block; margin: 0 5px 0 20px;"> (2/2)
    </span>
  </span>
</div>

<div style="width:1250px; margin:0 auto; position:relative;font-family:'微軟正黑體',Arial" *ngIf="((clo029|async)?.length??0)>18">
  <img *ngIf="((clo024|async)?.count??0)>=1" src="images/IDBG.jpg" style="width:100%; height:auto;">
  <img *ngIf="((clo024|async)?.count??0)==0" src="images/IDBG_e.jpg" style="width:100%; height:auto;">
  <div style="position:absolute; width:620px; top:60px; right:260px; text-align:right;">
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613;">學生</span>
    <span
      style="font-size:36px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.cH_NAME}}</span>
    <span style=" display:block; margin: 0; font-size:20px; font-weight:bold; color:#221613; margin-top:0;">在本校修習</span>
    <span style="font-size:32px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_NAME}}
      <span style=" color:#221613;">成績及格</span></span>
    <span style=" display:block; margin-top: 10px; font-size:15px; font-weight:bold; color:#221613; line-height:28px;">
      This certifies that <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo013|async)?.engname}}</span><br>
      has completed the requirements of <span
        style="font-size:22px; font-weight:bold; display:inline-block; color:#8b5c2e;">{{(clo024|async)?.proG_ENG_NAME}}</span>
    </span>
    <ul style=" margin-top:20px; border-right:#e6c5c1 1px solid;">
      <span
        style=" display:inline-block; padding: 0 10px 5px 0; border-right:#e6c5c1 1px solid; width:495px;"><b>課程名稱</b><br><span
          style="font-size:15px;">Course</span></span><span
        style=" width:60px; display:inline-block; padding: 0 10px 5px 0;"><b>學分數</b><br><span
          style="font-size:15px;">Credits</span></span>
      <li *ngFor="let t of (clo029|async) |  slice:19:27; let i=index" style="list-style:none; font-size:11px;">
        <span style=" display:inline-block; width:495px; padding-right:10px; border-right:#e6c5c1 1px solid;">
          <span
            style="font-size:15px; font-weight:bold; display:block; color:#8b5c2e; padding-top:7px;">{{t.cH_LESSON}}</span>{{t.enG_LESSON}}</span><span
          style=" width:60px; display:inline-block; vertical-align: top; padding-right:10px; font-size:22px; font-weight:bold; color:#8b5c2e;">{{t.crd}}</span>
      </li>
    </ul>
  </div>
  <span
    style=" position:absolute; right:280px; text-align:right; width:710px; display:block; bottom:55px; font-size:13px; color:#333; font-weight:bold;"><img
      src="images/vC.gif" width="120" height="24" align="absmiddle"
      style="display:inline-block; margin-right:20px;"><span
      style="color:#8d2c2d; display:inline-block; margin: 0 5px;">Issued │ </span>
    {{today|date:'MMMM dd yyyy'}}
    <!-- <span
      style="color:#8d2c2d; display:inline-block; margin: 0 5px 0 20px;">Valid Certificate ID │
    </span>@(Model.CERTIFICATEID) -->
  </span>
</div>
